import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
import { api } from '../../api/client';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await api.post('/api/admin/login', { username, password });
      nav('/admin');
    } catch (err) {
      const message = (err as { message?: string }).message ?? 'Pålogging feilet';
      setError(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-full flex items-center justify-center bg-slate-100">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white rounded-lg shadow p-8 space-y-4"
      >
        <div className="flex items-center gap-2 mb-4">
          <CreditCard className="text-brand" size={28} />
          <h1 className="text-xl font-semibold">Pay admin</h1>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Brukernavn</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full rounded border border-slate-300 px-3 py-2"
            autoFocus
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Passord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded border border-slate-300 px-3 py-2"
            required
          />
        </div>
        {error && <div className="text-sm text-red-600">{error}</div>}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-brand hover:bg-brand-dark text-white rounded py-2 font-medium disabled:opacity-50"
        >
          {loading ? 'Logger inn …' : 'Logg inn'}
        </button>
      </form>
    </div>
  );
}
